import React, { useState } from 'react';
import DialogComponent from '../dialog/dialog.component';
import { requestFeartureDonate } from '../../api';
import toast from 'react-hot-toast';
import useVietQR from '../../hooks/use-bank/use-bank';
import { useConsentGate } from '../../hooks/use-consent-gate';
import { ekycErrorMessage } from '../../pages/donate-goal/ekyc-flow';

// label/onSubmitted: trang chi tiết chiến dịch dùng nút này với chữ "Đăng ký làm creator" và cần biết đã gửi xong để hiện "đang chờ duyệt".
// disabled: Cài đặt Donate tắt nút khi chưa đạt điều kiện bắt buộc hoặc chưa tới ngày được gửi lại.
// Không còn ô nhập số căn cước: danh tính lấy từ bước eKYC.
const RequestUnlockDonate = ({
  label = 'Yêu cầu mở khóa',
  onSubmitted,
  disabled = false,
}: {
  label?: string;
  onSubmitted?: () => void;
  disabled?: boolean;
}) => {
  const donateGate = useConsentGate('donate');
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [content, setContent] = useState('');
  const [selectedBank, setSelectedBank] = useState('');
  const [accountName, setAccountName] = useState<any>('');
  const handleBankChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedBank(e.target.value);
  };
  const { banks } = useVietQR();

  const toggleDialog = () => {
    setIsDialogOpen(!isDialogOpen);
  };

  const handleSubmit = async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      await requestFeartureDonate({
        referenceLinks: content.trim(),
        bankAccount: accountName,
        bankName: selectedBank,
      });
      onSubmitted?.();
      toast.success('Bạn đã gửi yêu cầu. Cab sẽ xem và trả lời bạn sớm.', {
        duration: 4000,
        position: 'top-center',
      });
      setIsDialogOpen(false);
    } catch (err) {
      // Máy chủ báo lý do bằng tiếng Việt ở `detail` (chưa đạt điều kiện, đang chờ duyệt, chưa tới ngày gửi lại).
      toast.error(ekycErrorMessage(err, 'Cab chưa gửi được yêu cầu. Bạn thử lại sau nhé.'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="bg-[#0057FF] mx-auto text-white p-2 rounded-xl px-4 pt-1 text-md font-semibold w-fit disabled:cursor-not-allowed disabled:opacity-50"
        onClick={toggleDialog}
        disabled={disabled}
      >
        {label}
      </button>
      <DialogComponent
        onClose={() => setIsDialogOpen(false)}
        visible={isDialogOpen}
        placement="CENTER"
        title="Mở nhận donate"
        size="full"
        customSize="w-full max-w-[976px]"
      >
        <div className="w-full">
          <div className="flex flex-col p-6">
            <div className="mt-4">
              <label
                htmlFor="content"
                className="block text-sm font-medium text-gray-700"
              >
                Link kênh của bạn
              </label>
              <p className="mt-0.5 text-xs text-gray-500">
                Bạn có thể bỏ trống nếu chưa có kênh ở nơi khác.
              </p>
              <textarea
                name="content"
                id="content"
                value={content}
                onChange={(e) => setContent(e.target.value)}
                className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                placeholder="Bạn dán link Facebook, YouTube, Instagram, TikTok hoặc website của mình"
              />
            </div>
            <div className="mt-4">
              <label
                htmlFor="bank"
                className="block text-sm font-medium text-gray-700"
              >
                Ngân hàng
              </label>
              <select
                name="bank"
                id="bank"
                value={selectedBank}
                onChange={handleBankChange}
                className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-600 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
              >
                <option value="" disabled>
                  Chọn ngân hàng
                </option>
                {banks.map((bank) => (
                  <option key={bank?.id} value={bank?.code}>
                    {bank?.shortName}
                  </option>
                ))}
              </select>
            </div>
            <div className="mt-4">
              <label
                htmlFor="accountName"
                className="block text-sm font-medium text-gray-700"
              >
                Tên tài khoản ngân hàng
              </label>
              <input
                name="accountName"
                id="accountName"
                value={accountName}
                onChange={(e) => setAccountName(e.target.value)}
                className="mt-1 block w-full pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                placeholder="Nhập tên tài khoản"
              />
            </div>
          </div>

          <div className="mt-4 flex justify-end p-6">
            <button
              onClick={() => donateGate.run(handleSubmit)}
              disabled={submitting}
              className="disabled:opacity-50 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              {submitting ? 'Đang gửi…' : 'Gửi'}
            </button>
          </div>
        </div>
      </DialogComponent>
      {donateGate.modal}
    </>
  );
};

export default RequestUnlockDonate;
